var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { cancel, fork, take } from '@redux-saga/core/effects';
export var takeLatestWithPayload = function (patternOrChannel, saga) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return fork(function () {
        var lastTaskHash, action, hash, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    lastTaskHash = {};
                    _c.label = 1;
                case 1:
                    if (!true) return [3, 6];
                    return [4, take(patternOrChannel)];
                case 2:
                    action = _c.sent();
                    hash = JSON.stringify({
                        type: action.type,
                        payload: action.payload,
                    });
                    if (!lastTaskHash[hash]) return [3, 4];
                    return [4, cancel(lastTaskHash[hash])];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    _a = lastTaskHash;
                    _b = hash;
                    return [4, fork.apply(void 0, __spreadArrays([saga], args.concat(action)))];
                case 5:
                    _a[_b] = _c.sent();
                    return [3, 1];
                case 6: return [2];
            }
        });
    });
};
//# sourceMappingURL=saga.js.map